<template>
    <div class="modal fade" id="assign-contract-modal" tabindex="-1" role="dialog" aria-labelledby="assign-contract-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title" id="assign-contract-title">Assign Payer Contract</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div class="list-group">
                        <template v-for="contract in contracts">
                            <button type="button" :class="['list-group-item list-group-item-action', {'active': selectedContractId == contract.id}]" :key="'assign-contract-' + contract.id" @click="selectedContractId = contract.id">
                                {{ contract.description }}
                            </button>
                        </template>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary" data-dismiss="modal" @click="assign()" :disabled="!selectedContractId">Assign</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                     
                </div>                                           
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            clientId: null,
            claimId: null,
            serviceFormId: null,
            historical: false,
            contracts: [],
            selectedContractId: null
        }
    },
    methods: {
        show: function (clientId, claimId, serviceFormId, historical) {

            this.clientId = clientId;
            this.claimId = claimId;
            this.serviceFormId = serviceFormId;
            this.historical = historical;
            this.selectedContractId = null;

            axios.get(`/ajax/clients/${this.clientId}/active/contracts`)
            .then(response => {
                this.contracts = response.data.contracts;
                $('#assign-contract-modal').modal('show');
            })
            .catch(error => {
                console.log(error.resonse);
            })

        },
        assign: function() {

            let url = this.historical ?
                `/ajax/clients/${this.clientId}/claims/${this.claimId}/historical/services/${this.serviceFormId}/contract/${this.selectedContractId}` :
                `/ajax/clients/${this.clientId}/claims/${this.claimId}/services/${this.serviceFormId}/contract/${this.selectedContractId}`;

            axios.patch(url)
            .then(repsonse => {})
            .catch(error => {});
        }
    },
    created() {
        eventHub.$on('show-assign-contract-modal', this.show);
    },
    destroyed() {
        eventHub.$off('show-assign-contract-modal');
    }
}
</script>

<style scoped>

</style>